import { Filter, Trash } from 'lucide-react'

import { StudyObjectGroupCompareEnum } from '../../analytics-details-v2/view/readership-profile/configs/StudiesObjectsCompareGroupTypesConfig'
import RecapInputTag from '../../analytics-details-v2/view/readership-profile/inputs/recap/RecapInputTag'
import NewAudienceTag from '../../audience/new-audience/NewAudienceTag'
import { Button } from '../../ui/button'
import { SetColorConfig } from '../../../core/config/SetColorConfig'
import { BookInterface } from '../../../core/interface/book.interface'
import { TableViewTypeInfluencerEnum } from '../../../core/enums/table-view-type-influencer.enum'

const RecapChroniqueur = ({
  viewType,
  selectedUsersCount,
  bookSelected,
  setShowFilters,
  showFilters,
  handleResetFiltersAndSelections,
}: {
  viewType: TableViewTypeInfluencerEnum
  selectedUsersCount: number
  bookSelected: BookInterface[] | string
  setShowFilters?: (show: boolean) => void
  showFilters?: boolean
  handleResetFiltersAndSelections?: () => void
}) => {
  return (
    <div className="w-full h-14 bg-white rounded-xl flex flex-row items-center justify-center px-8 py-2 text-[#252525] mx-auto mb-8 relative ">
      <div className="flex flex-row gap-2 items-center">
        {viewType === TableViewTypeInfluencerEnum.INFLUENCERS_VIEW ? (
          <span className="font-semibold">Influencers</span>
        ) : (
          <>
            <span className="text-base">Je réalise une chronique sur</span>
            {Array.isArray(bookSelected) ? (
              <RecapInputTag
                type={StudyObjectGroupCompareEnum.TITLE}
                value={bookSelected}
                color={SetColorConfig[0].color1}
                booksSelected={bookSelected}
              />
            ) : (
              <span className="font-semibold">{bookSelected}</span>
            )}
          </>
        )}

        <div className="absolute right-0 flex gap-2 items-center text-sm">
          <NewAudienceTag
            color="#8B5CF6"
            label={`${selectedUsersCount} utilisateurs sélectionnés`}
          />
          {setShowFilters && (
            <Button
              variant="default"
              onClick={() => setShowFilters(!showFilters)}
              size="icon"
            >
              <Filter className="h-4 w-4" />
            </Button>
          )}
          {handleResetFiltersAndSelections && (
            <Button
              variant="destructive"
              size="icon"
              onClick={() => {
                handleResetFiltersAndSelections()
              }}
              className="ml-2 bg-red-600 hover:bg-red-700 text-white"
            >
              <Trash className="h-4 w-4 text-white" />
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

export default RecapChroniqueur
